<script setup>
import {defineProps, defineModel, computed} from 'vue';
import InputText from "primevue/inputtext";
const props = defineProps({
  id: [String, Array],
  label: String,
  errors: Object,
  autocomplete: String
})
// eslint-disable-next-line no-unused-vars
const model = defineModel();
const ids = computed(()=> {
  if(!Array.isArray(props.id)){
    return [props.id];
  }
  return props.id;
})
</script>

<template>
  <div class="great-input">
    <label :for="ids[0]">{{ label }}</label>
    <template v-for="(id, i) in ids" :key="id">
      <InputText :id="id" v-model="model[id]" :invalid="errors[id] !== undefined" :autocomplete="autocomplete+(Array.isArray(props.id) ? i+1:'')" class="input-text"/>
      <small v-if="errors[id] !== undefined">{{ errors[id][0] }}</small>
    </template>
  </div>
</template>

<style scoped lang="scss">
.great-input {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  .input-text {
    margin-top: 8px;
    width: 300px;
  }
  label {
    font-size: 14px;
  }
  small {
    color: red;
  }
}
</style>
